import React from 'react'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import Group from 'components/utils/Group'
import Typography from 'LuxKit/Typography/Typography'
import FormatCurrency from '../FormatCurrency'
import { FilterPanelCheckItem } from './FilterPanelCheckboxGroup'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'

interface Props {
  name: string;
  item: FilterPanelCheckItem;
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  titlecase?: boolean;
  maxValue?: number;
  loadingValue?: boolean;
}

function FilterPanelCheckboxGroupItem(props: Props) {
  const {
    onChange,
    name,
    item,
    defaultChecked,
    checked,
    titlecase = false,
    maxValue = 1000,
    loadingValue,
  } = props

  const showLabelOnly = item.price === undefined && typeof item.count !== 'number'
  const showCount = typeof item.count === 'number' && item.price === undefined
  const showPrice = item.price !== undefined

  return (
    <CheckboxInput
      key={item.value}
      name={name}
      value={item.value}
      size="large"
      onChange={onChange}
      defaultChecked={defaultChecked}
      checked={item.checked ?? checked}
      hidden={item.hidden}
      data-carrier={item.value}
    >
      {showCount && (
        <Group direction="horizontal" horizontalAlign="space-between">
          {item.label}
          {loadingValue && <TextLoadingBox width="3ch" />}
          {!loadingValue && <>
            {item.count! > maxValue ? (<span>({maxValue}+)</span>) : <span>({item.count})</span>}
          </>}
        </Group>
      )}

      {showPrice && (
        <Group direction="horizontal" horizontalAlign="space-between" gap="0 4">
          {item.label}

          <span>
            <FormatCurrency
              value={item.price!}
              format="roundedDollar"
            />
          </span>
        </Group>
      )}

      {showLabelOnly && (
        <Typography format={titlecase ? 'titlecase' : undefined} as="span">
          {item.label}
        </Typography>
      )}
    </CheckboxInput>
  )
}

export default FilterPanelCheckboxGroupItem
